import { useEffect, useState } from "react";
import { listAppUsers, labelForUserKey, type AppUser } from "../services/userService";

/**
 * Resolves stored user keys (ids) to display names. Bearbeiter /
 * Hauptverantwortliche are persisted as user-ids; everywhere they are shown we
 * must render the name, never the raw id. Backed by the cached `/users` list.
 */
export function useUserLabels() {
    const [users, setUsers] = useState<AppUser[]>([]);
    const [loaded, setLoaded] = useState(false);

    useEffect(() => {
        listAppUsers()
            .then(setUsers)
            .finally(() => setLoaded(true));
    }, []);

    const label = (key?: string | null): string =>
        key ? labelForUserKey(key, users, { loading: !loaded }) : "—";

    const labels = (keys?: Array<string | null | undefined>): string => {
        const list = (keys ?? []).filter((k): k is string => !!k);
        return list.length ? list.map((k) => label(k)).join(", ") : "—";
    };

    return { users, label, labels };
}
